module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAAAXNSR0IArs4c6QAAAKhJREFUKBWdkD0OgkAUhGdWE0uu4J1I6KyMdBSbSG9tSLR1ORBH4Q40yED4EWVRX7LJ291vvmKYX+0DqGP8NXQm2AcJieLXvDLKmii6VLstQpDl15KGVUZZo9DB3kuDTUiwWpOIEauM2Fag5ZhmRW2QaPeNGLE9Mwj0cDrfHMDmLA1dx4z/LwI9L5XalzZGu+1N8LHUSWmrAgHTUuelzQXee57ZWMcHPQHOSTaRbOnOggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/triangle-on@2x.png
// module id = 134
// module chunks = 0